import CardCustomerStory from '../components/CardCustomerStory';
import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';
import { AnimatePresence, motion } from 'motion/react';

function PageCustomerStories() {
  const { content: { cisco_customer_stories: content } } = useAppStore();
  
  return (
    <Page className='flex space-between overflow-hidden pt-624u pb-250u pr-220u relative'>
      <div className='absolute top-200u left-1/2 text-120u font-extralight -translate-x-1/2 z-30'>{content.title}</div>
       <div 
          className='absolute top-400u left-1/2 text-42u font-light -translate-x-1/2 text-center'>Hear firsthand from Cisco customers as they share their success stories and how our products have helped drive their growth and innovation.</div>
      <div className="flex flex-row h-full gap-94u">
        <AnimatePresence>
          {content.items.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20, filter: "blur(3px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{
                duration: 0.6,
                ease: "easeOut",
                delay: index * 0.5
              }}
              className="flex-1"
            >
              <CardCustomerStory
                item={item}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </Page>
  );
}

export default PageCustomerStories;